import LoadingSpan from "../LoadingSpan";
import ErrorSpan from "../ErrorSpan";
import UserSpan from "./UserSpan";
import { TypographyVariant } from "@mui/material";
import { useUser } from "../../../app/hooks";

function UserSpanLoader(props: { id: number; variant?: TypographyVariant }) {
  const { id, variant } = props;

  const { user, loading, error } = useUser(id);

  let comp = <></>;

  if (loading) {
    comp = <LoadingSpan variant={variant} />;
  } else if (error) {
    comp = <ErrorSpan error={error} variant={variant} />;
  } else if (user !== null) {
    comp = <UserSpan user={user} variant={variant} />;
  }

  return comp;
}

export default UserSpanLoader;
